module.exports = __webpack_public_path__ + "img/wechat-qr.811590ee.png";